/**
 * Mock mode only (VITE_USE_MOCKS): work locations created through the Business Profile mock (Step 5, or the Add Work Location prompt on Add
 * Employee / the employee profile) that the people mock must also offer. In production both screens read the one `/api/work-locations`
 * table, so this registry just reproduces that single source for the in-memory mocks. It never reaches a real API.
 */
export interface MockRegisteredWorkLocation {
  id: string;
  name: string;
  locationCode: string;
  status: string;
  isDefault: boolean;
}

let registered: MockRegisteredWorkLocation[] = [];

export const mockWorkLocationRegistry = {
  /** Adds or updates a location by id. */
  upsert(location: MockRegisteredWorkLocation): void {
    registered = [...registered.filter((l) => l.id !== location.id), { ...location }];
  },
  remove(id: string): void {
    registered = registered.filter((l) => l.id !== id);
  },
  list(): MockRegisteredWorkLocation[] {
    return registered.map((l) => ({ ...l }));
  },
  reset(): void {
    registered = [];
  },
};
